/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase/app'
import "firebase/auth";
import 'firebase/analytics'
import { EVENT_REFRESH_VISITS, EventBus } from '../utils/EventBus';
import { uid } from 'uid';
import { analytics, events } from '../utils/analitics';
import { apollo } from '../plugins/apollo';
import SAVE_AGREEMENT from '../graphql/save_agreement.gql';
import ADD_CLAUSE from '../graphql/add_clause.gql'
import REMOVE_CLAUSE from '../graphql/remove_clause.gql'
import UPDATE_CLAUSE from '../graphql/update_clause.gql'
import CLAUSES from '../graphql/clauses.gql'
import LOG_VISIT from '../graphql/log_visit.gql';
import { ADD_BANK, GET_BANKS, REMOVE_BANK, UPDATE_BANK } from '../graphql'
import ARCHIVE_AGREEMENT from '../graphql/archive_agreement.gql';

const getUrlQueryObject = () => {
  return window.location.search
    .slice(1)
    .split('&')
    .map(p => p.split('='))
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
}

const actions = {
  updateClausesPerPage ({ commit }, value) {
    commit('UPDATE_CLAUSES_PER_PAGE', value)
  },
  async logout({ commit }) {
    return new Promise((resolve, reject) => {
      firebase.auth().signOut().then(() => {
        resolve();
      }).catch(reject)
    })
  },
  clearUserInfo({ commit }) {
    commit('UPDATE_USER_INFO', {});
    commit('UPDATE_USER_TOKEN', '');
  },

  async login() {

  },

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload.user)
    commit('UPDATE_USER_TOKEN', payload.token)
  },

  async logVisit({ commit }, payload) {
    const tracking_id = uid();

    await apollo.mutate({
      mutation: LOG_VISIT,
      variables: {
        id: tracking_id
      }
    })
    await analytics.setUserId(tracking_id);
    await analytics.logEvent(events.view_item);
    commit('SET_ID', tracking_id);

    if (getUrlQueryObject().hasOwnProperty('dev') && getUrlQueryObject()['dev'] === 'true') {
      commit('SET_DEV_MODE');
    }
  },

  async archiveVisit({ commit }, payload) {
    await apollo.mutate({
      mutation: ARCHIVE_AGREEMENT,
      variables: {
        id: payload
      }
    });
    await apollo.cache.reset();
    EventBus.$emit(EVENT_REFRESH_VISITS);
  },

  async reloadBanks({ commit }) {
    const { data: { banks } } = await apollo.query({
      query: GET_BANKS
    });

    console.log("BANKS", banks);

    commit('SET_BANKS', banks);
  },
  addBank({ commit, state }, payload) {
    console.log("P", payload);
    commit('ADD_BANK', { name: payload });

    return apollo.mutate({
      mutation: ADD_BANK,
      variables: {
        name: payload
      }
    })

    // return db.collection(collection.config).doc('banks').set(state.banks.reduce((p, n, i) => ({ ...p, [i]: n }), {}))
  },
  updateBank({commit, state}, payload) {
    commit('RENAME_BANK', payload);

    return apollo.mutate({
      mutation: UPDATE_BANK,
      variables: {
        old: payload.old,
        new: payload.new
      }
    })
  },
  removeBank({ commit, state }, payload) {
    commit('REMOVE_BANK', { name: payload });

    return apollo.mutate({
        mutation: REMOVE_BANK,
        variables: {
          name: payload
        }
      }
    )

    // return db.collection(collection.config).doc('banks').set(state.banks.reduce((p, n, i) => ({ ...p, [i]: n }), {}))
  },
  incFileOrder({ commit }) {
    commit('INC_FILE_ORDER')
  },
  async reloadClauses({ commit }) {
    const { data: { clauses } } = await apollo.query({
      query: CLAUSES
    })
    commit('SET_CLAUSES', clauses);

  },
  async addClause({ commit }, payload) {
    payload.id = uid()
    console.log("PL", payload);
    const res = await apollo.mutate({
      mutation: ADD_CLAUSE,
      variables: {
        ...payload
      }
    });
    commit('ADD_CLAUSE', { ...payload });
    return res;
  },
  async removeClause({ commit }, payload) {

    console.log("PL", payload);
    const res = await apollo.mutate({
      mutation: REMOVE_CLAUSE,
      variables: {
        id: payload
      }
    });
    commit('REMOVE_CLAUSE', payload)
    return res;
  },
  async setClause({ commit, state }, payload) {
    const index = state.clauses.findIndex(clause => clause.id === payload.id);
    if (index === -1) throw new Error('Nie możesz aktualizować klauzuli, która nie istnieje');
    console.log("PL", payload);

    const { data: { updateOneClause: { id } } } = await apollo.mutate({
      mutation: UPDATE_CLAUSE,
      variables: {
        id: payload.id,
        text: payload.text,
        bank: payload.bank
      }
    });

    console.log("ID", id);
    payload.archived = false;
    commit('ADD_CLAUSE', { ...payload, id, prev: payload.id });
    commit('REMOVE_CLAUSE', payload.id);
    return id;
  },
  toggleTruncate({ commit, state }) {
    console.log("toggleTruncate", state.truncate);
    commit('SET_TRUNCATE', !state.truncate)
  },
  randomizeId({ commit }) {
    commit('SET_ID', uid());
  },
  async confirm_agreement({ commit, state }, payload) {
    const id = state.id;

    const variables = {
      data: {
        email: payload.email,
        is_premium: payload.premiumSupport,
        name: payload.name,
        surname: payload.surname,
        phone: payload.phone,
        info: payload.info,
        tracking_id: id,
        bank: payload.bank,
        file_ids: payload.pages.map(({ id }) => id)
      }
    };

    console.log("PAYLOAD", payload);

    console.log("VARIABLES", variables);

    const { data } = await apollo.mutate({
      mutation: SAVE_AGREEMENT,
      variables
    });

  },
}

export default actions
